import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreAgentConversationHeaderSlice } from './get';

export const coreAgentConversationHeaderReducers = combineReducers({
	get: getCoreAgentConversationHeaderSlice.asyncReducers
});

export const coreAgentConversationHeaderWatchers = combineAllWatchers([
	getCoreAgentConversationHeaderSlice.asyncWatchers
]);
